<template>
    <v-dialog width="800px" v-model="show" lazy>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title>{{$t(formProperties.title)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm">
                <form id="formProcess">
                    <v-tabs color="cyan" dark v-model="tabs"
                            v-if="formProperties['tabs'] != null && formProperties['tabs'].length >0" slider-color="yellow">
                        <v-tab v-for="tab in formProperties['tabs']" :key="tab.key">
                            {{ tab.name }}
                        </v-tab>
                        <v-tabs-items style="padding: 10px">
                            <v-tab-item v-for="tab in formProperties['tabs']" :key="tab.key">
                                <div v-for="item in lstModel">
                                    <div v-if="item.properties['container'] == tab.name">
                                        <v-text-field v-if="item.type=='Hidden'" style="display:none"
                                                      v-model.trim="values[item.properties['name']]"
                                                      v-bind="item.properties"></v-text-field>
                                        <c-textbox v-if="item.type=='Textbox'"
                                                   v-model.trim="values[item.properties['name']]"
                                                   v-bind="item.properties" ref="input"></c-textbox>
                                        <i-datepicker v-if="item.type=='DateField'"
                                                      v-model="values[item.properties['name']]"
                                                      v-bind="item.properties" ref="input"/>
                                        <v-textarea v-if="item.type=='Textarea'"
                                                    v-model.trim="values[item.properties['name']]"
                                                    v-bind="item.properties" ref="input"></v-textarea>
                                        <i-selectbox v-if="item.type=='SelectBox'"
                                                     v-model="values[item.properties['name']]"
                                                     v-bind="item.properties" @change="showValues"
                                                     :variable="values" ref="input"></i-selectbox>

                                        <v-radio-group v-if="item.type=='Radio'"
                                                       v-model="values[item.properties['name']]"
                                                       v-bind="item.properties" ref="input">
                                            <v-radio v-for="option in item.properties['items']" :label="option"
                                                     :value="option"
                                                     :key="option"></v-radio>
                                        </v-radio-group>
                                        <v-checkbox v-if="item.type=='Checkbox'"
                                                    v-model="values[item.properties['name']]"
                                                    v-bind="item.properties"></v-checkbox>

                                        <i-upload v-if="item.type=='Upload'"
                                                  v-model="values[item.properties['name']]"
                                                  v-bind="item.properties" ref="input" :variable="values"></i-upload>
                                        <i-data-table v-if="item.type=='DataTable'"
                                                      v-model="values[item.properties['name']]"
                                                      :variable="values"
                                                      v-bind="item.properties" ref="input"></i-data-table>
                                        <i-entity-table v-if="item.type=='Entity'"
                                                        v-model="values[item.properties['name']]"
                                                        :variable="values"
                                                        v-bind="item.properties"></i-entity-table>
                                        <component v-if="item.type=='Component'"
                                                   v-model="values[item.properties['name']]"
                                                   :variable="values" :is="item.component"
                                                   v-bind="item.properties"></component>
                                    </div>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                    <div v-else style="padding: 10px">
                        <div v-for="item in lstModel">
                            <v-text-field v-if="item.type=='Hidden'" style="display:none"
                                          v-model.trim="values[item.properties['name']]"
                                          v-bind="item.properties"></v-text-field>
                            <c-textbox v-if="item.type=='Textbox'" v-model.trim="values[item.properties['name']]"
                                       v-bind="item.properties" ref="input"></c-textbox>
                            <i-datepicker v-if="item.type=='DateField'" v-model="values[item.properties['name']]"
                                          v-bind="item.properties" ref="input"/>
                            <v-textarea v-if="item.type=='Textarea'" v-model.trim="values[item.properties['name']]"
                                        v-bind="item.properties" ref="input"></v-textarea>
                            <i-selectbox v-if="item.type=='SelectBox'" v-model="values[item.properties['name']]"
                                         v-bind="item.properties" @change="showValues"
                                         :variable="values" ref="input"></i-selectbox>
                            <v-radio-group v-if="item.type=='Radio'" v-model="values[item.properties['name']]"
                                           v-bind="item.properties" ref="input">
                                <v-radio v-for="option in item.properties['items']" :label="option" :value="option"
                                         :key="option"></v-radio>
                            </v-radio-group>
                            <v-checkbox v-if="item.type=='Checkbox'" v-model="values[item.properties['name']]"
                                        v-bind="item.properties"></v-checkbox>

                            <i-upload v-if="item.type=='Upload'" v-model="values[item.properties['name']]"
                                      v-bind="item.properties" ref="input" :variable="values"></i-upload>
                            <i-data-table v-if="item.type=='DataTable'" v-model="values[item.properties['name']]"
                                          :variable="values"
                                          v-bind="item.properties" ref="input"></i-data-table>
                            <i-entity-table v-if="item.type=='Entity'" v-model="values[item.properties['name']]"
                                            :variable="values"
                                            v-bind="item.properties"></i-entity-table>
                            <component v-if="item.type=='Component'" v-model="values[item.properties['name']]"
                                       :variable="values" :is="item.component"
                                       v-bind="item.properties"></component>
                        </div>
                    </div>
                </form>
                <component :is="formComponent" v-on:mounted="formViewLoad" ref="formView"></component>
                <form id="componentForm">
                </form>
            </v-form>
            <div style="text-align: right">
                <v-btn v-if="this.$store.state.auth.accessLevel == 2" color="primary" dark @click="onSave" v-show="isEdit">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="orange darken-2" dark @click="onComplete" v-show="isEdit && taskId != null">
                    <v-icon dark left>check_circle</v-icon>
                    {{$t('lang.common.complete')}}
                </v-btn>
                <v-btn color="error" dark @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    import formStyle from "../../../../public/plugin/form/form.css"
    import CTextbox from "../../../components/form/Textbox";
    import Validator from "../../../../public/js/validator";
    import FormGenerator from "../../../../public/plugin/form/form";
    import axios from "axios/index";
    import VueController from "../../../../public/js/controller";
    import IDatepicker from "../../../components/form/DatePicker";
    import ISelectbox from "../../../components/form/SelectBox";
    import path from "../../../router/paths";
    import IDataTable from "../../../components/form/DataTable";
    import IEntityTable from "../../../components/form/EntityForm";
    import {message} from "@/shared/message";
    import IUpload from "../../../components/form/Upload";
    //import Component from "vue2-google-maps/examples/src/auto/component";

    //console.log(path);
    const v = Validator();


    export default {
        name: 'form-input',
        components: {IUpload, IEntityTable, IDataTable, ISelectbox, IDatepicker, CTextbox, Validator},
        inheritAttrs: true,
        props: {
            formName: {
                type: String,
                default: 'form'
            },
        },
        data: () => {
            return {
                values: {},
                show: false,
                isEdit: true,
                processDefinitionId: null,
                lstModel: [],
                taskId: null,
                formCode: null,
                executionId: null,
                formProperties: {},
                formComponent: null,
                tabs:null
            }
        },
        watch: {
            values: function (data) {
                console.log("--- update values ---");
                console.log(data);
                //this.loadData(this.source, this.valueField, this.value);
            },

            show: function(data){
                if(data == false){
                    this.values = {};
                    this.lstModel = {};
                    this.formProperties = {};
                }
            }
        },
        created() {
            VueController.push(this);
            //console.log("--- root component ---");
            //console.log(this.$root.$options);

            axios.get("plugin/form/form.json").then(data => {
                //console.log("---config---");
                //console.log(data);
                FormGenerator.inputConfig = data;
                //FormGenerator.createInputPanel();
            }, error => {
                alert("Can't get form config");
            });
        },
        destroyed() {
            VueController.removeComponentByEl(this);
        },
        methods: {
            getComponentByName: function (componentName) {
                //
                // get from paths
                //
                for (let i = 0; i < path.length; i++) {
                    if (componentName == path[i].name) {
                        return path[i].component;
                    }
                }
                //
                // get from registered component
                //
                return null;
            },

            formViewLoad: function () {
                console.log("loaded");
                console.log(this.$refs.formView);
                this.$refs.formView.initFromFlow(this.values["executionId"]);
            },

            showValues: function () {
                console.log(this.values);
            },

            onStart: function () {
                //let formdata = FormGenerator.convertFormToJSON('formProcess');
                //console.log(this.values);
                let validate = v.validate(this);
                if (!validate) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios.post(process.env.VUE_APP_API_URL + "/task/start?processId=" + this.processDefinitionId, this.values).then(
                    response => {
                        alert("Process success");
                        this.show = false;
                        let tl = VueController.getComponentByComponentName("task-management");
                        tl.search();
                    }, error => {
                        message.error("Process false: " + error);
                    }
                );
            },

            onComplete: function () {
                let validate = v.validate(this);
                if (!validate) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios.post(process.env.VUE_APP_API_URL + "/task/complete?taskId=" + this.taskId, this.values).then(response => {
                    message.success("Process success");
                    this.show = false;
                    let tv = VueController.getComponentByComponentName("task-view");
                    tv.onCancel();
                }, error => {
                    message.error("Process false: " + jqXHR.responseText);
                });
            },

            onSave: function () {
                //this.runScript();
                if (this.taskId == null) {
                    this.onStart();
                } else {
                    //console.log(this.values);
                    axios.post(process.env.VUE_APP_API_URL + "/task/save?taskId=" + this.taskId, this.values).then(response => {
                        message.success("Process success");
                        this.show = false;
                        let tv = VueController.getComponentByComponentName("task-view");
                        //this.runScript();
                        tv.onCancel();
                    }, error => {
                        message.error("Process false: " + jqXHR.responseText);
                    });
                }

            },

            onShowForm: function (processDefinitionId, initData) {
                this.isEdit = true;
                this.processDefinitionId = processDefinitionId;
                this.taskId = null;
                if(initData != undefined && initData != null){
                    this.values = initData;
                } else {
                    this.values = {};
                }
                console.log(initData);
                let url = process.env.VUE_APP_API_URL + "/task/getStartFormKey?processDefinitionId=" + processDefinitionId;
                axios.post(url).then(
                    formCode => {
                        let formurl = process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + formCode;
                        this.initForm(formurl, false, null, this.onStart);
                    }
                )
            },

            showTaskData: function (formCode, executionId, taskId) {
                this.isEdit = true;
                this.taskId = taskId;
                //console.log(this.taskId);
                this.loadFormAndData(formCode, executionId);
            },

            viewTaskData: function (formCode, executionId, taskId) {
                this.isEdit = false;
                this.taskId = taskId;
                this.loadFormAndData(formCode, executionId);
            },

            initForm: function (url, loadVariable, executionId, method) {
                axios.post(url).then(
                    form => {
                        console.log(form);
                        if (form == null || form == "") {
                            if(this.isEdit == false){
                                message.error(this.$t("lang.task.noformToView"));
                                return;
                            }
                            method();
                        } else {
                            this.show = true;
                            //console.log(form.formConfig);
                            FormGenerator.loadFormModel(FormGenerator.decodeHTML(form.formConfig), "formProcess");
                            this.lstModel = FormGenerator.modelToInputProperties();
                            this.formComponent = null;
                            this.formProperties = FormGenerator.toFormProperties();
                            //console.log(this.formProperties);
                            if (this.formProperties.component == undefined || this.formProperties.component == "") {
                                if(this.formProperties["tabs"] != undefined && this.formProperties["tabs"] != null) {
                                    this.tabs = this.formProperties["tabs"][0].key;
                                }
                                this.formComponent = null;
                                for (let i = 0; i < this.lstModel.length; i++) {
                                    if (this.lstModel[i].properties["default"] != undefined && this.lstModel[i].properties["default"] != null) {
                                        this.values[this.lstModel[i].properties["name"]] = this.lstModel[i].properties["default"];
                                    }
                                }
                                for (let i = 0; i < this.lstModel.length; i++) {
                                    if (this.lstModel[i].type == "Component") {
                                        //console.log(this.lstModel[i].properties["componentName"]);
                                        this.lstModel[i].component = this.getComponentByName(this.lstModel[i].properties["componentName"]);
                                        try {
                                            //console.log(this.lstModel[i].properties["properties"]);
                                            if (this.lstModel[i].properties["properties"] != undefined && this.lstModel[i].properties["properties"] != null && this.lstModel[i].properties["properties"] != "") {
                                                let properties = JSON.parse(this.lstModel[i].properties["properties"]);
                                                for (let key in properties) {
                                                    this.lstModel[i].properties[key] = properties[key];
                                                }
                                            }
                                            //console.log(this.lstModel[i]);
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                }
                                console.log(this.values);

                            } else {
                                this.lstModel = [];
                                try {
                                    let componentName = this.formProperties.component;
                                    for (let i = 0; i < path.length; i++) {
                                        if (componentName == path[i].name) {
                                            this.formComponent = path[i].component;
                                            break;
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            }

                            if (loadVariable) {
                                axios.post(process.env.VUE_APP_API_URL + "/task/taskWorkingVariables?taskId=" + executionId).then(
                                    data => {
                                        //FormGenerator.loadInputData(data);
/*                                        let variable = data;
                                        //console.log(data);
                                        //variable = data;
/*
                                        for (let i = 0; i < this.lstModel.length; i++) {
                                            variable[this.lstModel[i].properties["name"]] = data[this.lstModel[i].properties["name"]];
                                        }

                                        console.log(variable);
*/                                        //this.values = variable;
                                        this.$set(this,"values",data);
                                        try {
                                            if (this.$refs.input != undefined && this.$refs.input != null && this.$refs.input.length > 0) {
                                                this.$refs.input[0].focus();
                                            }
                                        } catch(e){
                                            console.log(e);
                                        }
                                        //console.log(this.values);
                                    },
                                    error => {

                                    }
                                );
                            }
                        }
                    },
                    error => {

                    }
                );
            },

            loadFormAndData: function (formCode, executionId) {
                this.formCode = formCode;
                this.executionId = executionId;
                let url = process.env.VUE_APP_API_URL + "/form/getByCode?formCode=" + formCode;
                this.initForm(url, true, executionId, this.onComplete);
            },

            onCancel: function () {
                this.values = {};
                this.formProperties = {};
                this.lstModel = {};
                this.show = false;
            }
        }
    }
</script>
